import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { dashboardColors } from "routes/utils";

export const SalesView = ({ data, isFetching }: any) => {
  // Ensure data exists
  const seriesData = ((data?.res?.salesSeriesData!=null)?data?.res?.salesSeriesData:[]) || [];
  const drilldownData = ((data?.res?.salesDrillDownsData!=null)?data?.res?.salesDrillDownsData:[]) || [];
  const colors = dashboardColors;

  const options: Highcharts.Options = {
      chart: { type: "column" },
      title: { text: "Stacked Drilldown" },
       xAxis: {
      type: "category",
      labels: {
        useHTML: true,
        formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          return this.value as string; // ✅ Properly typed
        },
      },
    },
     
      yAxis: {
        title: { text: "Total Count" },
        stackLabels: { enabled: true },
      },
      tooltip: {
        shared: true,
        pointFormat:
          '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} kg</b><br/>',
      },
      credits: {
    enabled: false,
  },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: { enabled: true, format: "{point.y} kg" },
        },
      },
      colors,
      series: seriesData.map((s: any) => ({
        type: s.type,
        name: s.name,
        data: s.data.map((d: any) => ({
          name: d.name,
          y: d.y,
          drilldown: d.drilldown,
        })),
      })),
      drilldown: {
        series: drilldownData
        // drilldownSeries.map((d: any) => ({
        //   id: d.id,
        //   name: d.name,
        //   type: d.type,
        //   stack: d.stack,
        //   data: d.data.map((dd: any) => [dd.name, dd.y]),
        // })),
      },
    };

//   const options: Highcharts.Options = {
//     chart: {
//       type: "column",
//     },
//     title: {
//       text: "Sales Overview",
//     },
//     subtitle: {
//       text: "Click the columns to view more details",
//     },
//     xAxis: {
//       type: "category",
//     },
//     legend: {
//       enabled: false,
//     },
//     tooltip: {
//       pointFormat: "{point.name}: <b>{point.y} kg</b>",
//     },
//     plotOptions: {
//       series: {
//         borderWidth: 0,
//         dataLabels: {
//           enabled: true,
//           format: "{point.y} kg",
//         },
//       },
//     },
//     credits: {
//   enabled: false,
// },
// colors,
//     series: [
//       {
//         name: "Sales",
//         colorByPoint: true,
//         type: "column",
//         data: seriesData.map((item: any) => ({
//           name: item.name,
//           y: item.y,
//           drilldown: item.drilldown,
//         })),
//       },
//     ],
//     drilldown: {
//       series: drilldownData.map((item: any) => ({
//         id: item.id,
//         name: item.name,
//         type: item.type,
//         data: item.data.map((d: any) =>
//           Array.isArray(d) ? d : [d.name, d.y] // handle both formats
//         ),
//       })),
//     },
//   };

  return (
    <>
      <h2>Sales</h2>
      {isFetching ? <p>Loading...</p> : <HighchartsReact highcharts={Highcharts} options={options} />}
    </>
  );
};
